"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _screenfull = _interopRequireDefault(require("screenfull"));
var _reactUse = require("react-use");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _TileMenu = _interopRequireDefault(require("./TileMenu"));
var _useUISettings = require("./AppData/useUISettings");
var _peerTileUtils = require("./peerTileUtils");
var _constants = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var labelStyles = {
  position: "unset",
  width: "100%",
  textAlign: "center",
  transform: "none",
  mt: "$2",
  flexShrink: 0
};
var Tile = function Tile(_ref) {
  var peerId = _ref.peerId,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "100%" : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "100%" : _ref$height;
  var track = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectScreenShareByPeerID)(peerId));
  var peer = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectPeerByID)(peerId));
  var isAudioOnly = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.isAudioOnly);
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMouseHovered = _useState2[0],
    setIsMouseHovered = _useState2[1];
  var showStatsOnTiles = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.showStatsOnTiles);
  var label = (0, _peerTileUtils.getVideoTileLabel)({
    peerName: peer.name,
    isLocal: false,
    track: track
  });
  var fullscreenRef = (0, _react.useRef)(null);
  // fullscreen is for desired state
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    fullscreen = _useState4[0],
    setFullscreen = _useState4[1];
  // isFullscreen is for true state
  var isFullscreen = (0, _reactUse.useFullscreen)(fullscreenRef, fullscreen, {
    onClose: function onClose() {
      return setFullscreen(false);
    }
  });
  var isFullScreenSupported = _screenfull["default"].isEnabled;
  var audioTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectScreenShareAudioByPeerID)(peer === null || peer === void 0 ? void 0 : peer.id));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoTile.Root, {
    css: {
      width: width,
      height: height
    },
    "data-testid": "screenshare_tile",
    children: peer ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.StyledVideoTile.Container, {
      transparentBg: true,
      ref: fullscreenRef,
      css: {
        flexDirection: "column"
      },
      onMouseEnter: function onMouseEnter() {
        return setIsMouseHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        setIsMouseHovered(false);
      },
      children: [showStatsOnTiles ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.VideoTileStats, {
        audioTrackID: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.id,
        videoTrackID: track === null || track === void 0 ? void 0 : track.id
      }) : null, isFullScreenSupported && !isHeadless ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoTile.FullScreenButton, {
        onClick: function onClick() {
          return setFullscreen(!fullscreen);
        },
        children: isFullscreen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ShrinkIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExpandIcon, {})
      }) : null, track ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Video, {
        screenShare: true,
        mirror: peer.isLocal && (track === null || track === void 0 ? void 0 : track.source) === "regular",
        attach: !isAudioOnly,
        trackId: track.id,
        threshold: 0.05
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoTile.Info, {
        css: labelStyles,
        children: label
      }), isMouseHovered && !isHeadless && !(peer !== null && peer !== void 0 && peer.isLocal) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TileMenu["default"], {
        isScreenshare: true,
        peerID: peer === null || peer === void 0 ? void 0 : peer.id,
        audioTrackID: audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.id,
        videoTrackID: track === null || track === void 0 ? void 0 : track.id
      }) : null]
    }) : null
  });
};
var ScreenshareTile = /*#__PURE__*/_react["default"].memo(Tile);
var _default = ScreenshareTile;
exports["default"] = _default;